import { Component } from '@angular/core';

@Component({
  selector: 'button-renderer',
  template: `
    <button (click)="onClick($event)">{{ params.label }}</button>
  `,
})
export class ButtonDetectionDetailComponent {
  params: any;

  agInit(params: any): void {
    this.params = params;
  }

  onClick(event): void {
    if (this.params.onClick instanceof Function) {
      this.params.onClick(this.params);
    }
  }
}